import { TFunction } from 'i18next';

import { NAVBAR_MENU_KEYS } from '../constants/keys';
import { View } from '../../utils/types/assessment_types';

const VIEW_KEY_MAP: Record<View, string> = {
  Admin: NAVBAR_MENU_KEYS.views.admin,
  Participant: NAVBAR_MENU_KEYS.views.participant,
  HR: NAVBAR_MENU_KEYS.views.hr,
};

export const translateView = (t: TFunction, view: View): string =>
  t(VIEW_KEY_MAP[view]);
